<template>
  <div class="integration-editar">
    <SidebarLayout3
      :breadcrumb="breadcrumb"
      :rootPath="rootPath"
      :pageTitle="pageTitle"
      :separateTitle="true"
    >
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading class="page-actions--heading">
            Ações da página
          </Heading>
          <!-- CRIAR -->
          <Button class="page-actions--button" @click="updateConfigIntegration">
            {{ saveButtonLabel }}
          </Button>
          <!-- CANCELAR -->
          <Button
            :link="`/configuracoes-integracao`"
            element="router-link"
            class="page-actions--button"
            layout="outline"
          >
            CANCELAR
          </Button>
        </SidebarBlock>
      </template>
      <!-- CONTEÚDO PRINCIPAL -->
      <template #content>
        <!-- EXIBIÇÃO -->
        <div>
          <Heading class="heading__margin" level="3">
            Parâmetros do Hotel
          </Heading>
          <b-row align-v="center" class="fields-row">
            <b-col
              v-for="(item, index) in paramsAreNotRooms"
              :key="index"
              cols="3"
            >
              <FormInput
                v-model="item.codigoParceiro"
                :label="item.descricao"
              />
            </b-col>
            <b-col cols="3">
              <FormInput
                v-model="dataIntegrations.nomeServico"
                :success="true"
                :readonly="true"
                label="Nome Serviço"
            /></b-col>
          </b-row>
        </div>

        <SeparateLine :left="-10" :right="-10" />

        <!-- CONFIGURAÇÃO -->
        <div class="fieldset setup">
          <Heading class="heading__margin" level="3">
            Listagem dos quartos
          </Heading>
          <b-row align-v="center" class="fields-row">
            <b-col
              v-for="(item, index) in hotelRooms"
              :key="index"
              cols="3"
              class="fields-row--second-line"
            >
              <FormInput
                v-model="item.codigoParceiro"
                :label="item.descricao"
              />
            </b-col>
          </b-row>
        </div>
      </template>
    </SidebarLayout3>
  </div>
</template>

<script>
import SidebarLayout3 from '@/layouts/SidebarLayout3'
import SidebarBlock from '@/components/_base/patterns/SidebarBlock'
import Heading from '@/components/_base/elements/Heading'
import Button from '@/components/_base/elements/Button'
import FormInput from '@/components/_base/elements/FormInput'
import SeparateLine from '@/components/_base/patterns/SeparateLine'

export default {
  name: 'EditCoupon',
  components: {
    SidebarLayout3,
    SidebarBlock,
    Button,
    Heading,
    FormInput,
    SeparateLine
  },
  data() {
    return {
      rootPath: {
        /** ponto de partida do breadcrumb */
        label: 'Conversão',
        url: 'relatorio-conversao',
        isSpa: false /** se deve ser um link para o site novo ou antigo */
      },
      breadcrumb: [
        {
          label: 'Lista de integrações',
          url: '/configuracoes-integracao',
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        }
      ],
      pageTitle: '',
      showAlertChip: false,
      AlertChipMessage: 'Criado com sucesso.',
      saveButtonLabel: 'Salvar configurações',
      hotelId: null,
      dataIntegrations: '',
      hotelRooms: [],
      paramsAreNotRooms: []
    }
  },
  computed: {},
  created() {
    /** Pega o id do hotel que é passado como parâmetro da url */
    this.hotelId = this.$route.params.id

    this.$integrations.getHotelConfigs(this.hotelId).then((response) => {
      /** Objeto criado apartir da response */
      this.dataIntegrations = response.data
      /** Atribui o nome da página de acordo com o nome do hotel */
      this.pageTitle = this.dataIntegrations.configuracaoIntegracaoSistemas[0].descricao

      this.createFields()
    })
  },
  methods: {
    /** Esta função gera os campos de forma dinamica de acordo com o que é recebido na response de getHotelConfigs */
    createFields() {
      /** Seta o passo atual do breadcrumb */
      this.breadcrumb.push({
        label: 'Configuração de integração',
        url: '/configuracoes-integracao',
        isSpa: true /** se deve ser um link para o site novo ou antigo */
      })

      /** Filtra o elemento do tipo 'Quarto' */
      this.hotelRooms = this.dataIntegrations.configuracaoIntegracaoSistemas.filter(
        (configHotel) => configHotel.tipoObjetoDescricao === 'Quarto'
      )
      /** Filtra o elemento que não é do tipo 'Quarto' */
      this.paramsAreNotRooms = this.dataIntegrations.configuracaoIntegracaoSistemas.filter(
        (configHotel) => configHotel.tipoObjetoDescricao !== 'Quarto'
      )
    },
    /** Faz o post das configurações */
    updateConfigIntegration() {
      this.$integrations
        .updateHotelConfigs(this.dataIntegrations)
        .then((response) => {
          if (response.status === 200) {
            this.$bus.$emit('show-alert-chip', {
              message: 'Configuração de integração atualizada com sucesso'
            })
            setTimeout(() => {
              this.$router.push({
                path: '/configuracoes-integracao'
              })
            }, 1000)
          } else {
            this.$bus.$emit('show-alert-chip', {
              message: `${response.message}`
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.fieldset {
  & + & {
    padding-top: 30px;
    border-top: 1px solid $gray-border;
  }
}

.heading {
  &__margin {
    margin-bottom: 20px;
  }

  &__margin-2 {
    margin-bottom: 35px;
  }

  &__advice {
    margin-top: 10px;
    color: $blue;
    font-size: font-size('size-small');
  }
}

.fields-row {
  margin-bottom: 30px;
  &--second-line {
    margin-top: 35px;
  }
}

.setup {
  .fields-row {
    margin-bottom: 40px;
  }
}

.page-actions {
  &--heading {
    margin-bottom: 15px;
  }

  &--button {
    & + & {
      margin-top: 10px;
    }
  }
}
</style>
